module.exports = __webpack_public_path__ + "img/Middle-Vertical-Rectangular-Attachment-26.606202e7.png";